// @flow
import React from 'react'
import clsx from 'clsx'

import Checkbox from '@material-ui/core/Checkbox'
import makeStyles from '@material-ui/styles/makeStyles/makeStyles'

import CustomLabel from './CustomLabel'

type Props = {
  checked: boolean,
  label: any,
  handleChange: Function,
  children?: any,
  classNamelabel?: string,
  classCheckbox?: string,
  testId?: string,
}

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    maxHeight: '3vh',
  },
  label: {
    margin: '0 !important',
    fontSize: '13px !important',
  },
})

const CheckSimple = ({
  children = '',
  checked = false,
  label = '',
  handleChange = (noop) => noop,
  classNamelabel = '',
  classCheckbox = '',
  testId = 'CheckboxTester',
}: Props) => {
  const classes = useStyles()

  return (
    <div className={classes.container} onClick={() => !children && handleChange(!checked)}>
      <Checkbox
        checked={checked}
        onChange={() => handleChange(!checked)}
        color={'primary'}
        variant={'contained'}
        className={classCheckbox}
        data-testid={testId}
        disableRipple
      />
      <CustomLabel className={clsx(classes.label, classNamelabel)}>
        {label}
        {children}
      </CustomLabel>
    </div>
  )
}

export default CheckSimple
